import styled from 'styled-components'

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spc-sm);
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`

export const StyledSearchInputContainer = styled.div`
  position: relative;
  flex: 2;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: var(--spc-xs);
  min-width: 400px;
`

export const StyledSearchInput = styled.input`
  padding: var(--spc-xs) var(--spc-sm);
  font-size: var(--fs-sm);
  min-height: var(--spc-xs);
  border: none;
  border-bottom: 1px solid;
  border-color: var(--color-gray-5);
  border-radius: 3px;
  outline: none;
  border-bottom: 3px solid;
  border-bottom-color: var(--color-gray-5);

  &:focus {
    border-bottom-color: var(--color-gray-2);
  }
`

export const StyledResultsList = styled.ul`
  list-style: none;
  position: absolute;
  top: 2rem;
  background-color: white;
  width: calc(100%);
  border-radius: 5px;
  border: 1px solid;
  border-color: var(--color-gray-5);
  border-bottom: 5px solid;
  border-bottom-color: var(--color-gray-2);
  max-height: 250px;
  overflow: scroll;
  z-index: 100;

  li {
    font-size: var(--fs-sm);
    padding: 0.5rem;

    &:hover {
      background-color: var(--color-red-5);
      cursor: pointer;
    }
  }
`

export const StyledLabel = styled.span`
  padding: var(--spc-xs) 0;
  line-height: var(--spc-sm);
  font-size: var(--fs-sm);
  font-weight: bold;
  flex: 1;
`
